export default "__VITE_ASSET___k0n73J$__"